import { ring } from '@chakra-ui/react'
import {remCalc} from '../../../_utils'

const minicartFooter = {
    MinicartFooter: {
        baseStyle: () => ({
            wrapperfooter: {
                w: '100%',
                gap: 'spacing.4',
                color: 'color.border.black',
                textStyle: {base: 'paragraphSm', lg: 'paragraphMd'},
                fontWeight: '400',
                position: 'fixed',
                bottom: '0',
                right: '0',
                backgroundColor: 'color.background.white',
                p: remCalc(20),
            },

            subtotalSection: {
                w: '100%',
                gap: '0',
                marginBottom: 'spacing.6',
                justifyContent: 'space-between',
                letterSpacing: remCalc(4),
            },

            cartButton: {
                marginTop: 'spacing.4',
                textTransform: 'uppercase',
                fontWeight: '400',
                letterSpacing: remCalc(4),
            },

            expressSection: {
                w: '100%',
                gap: 'spacing.3',
                letterSpacing: remCalc(0.6),
            },

            expressLabel: {
                textStyle: 'paragraphMd',
            },

            notice: {
                w: '100%',
                marginTop: 'spacing.2.5',
                textStyle: 'paragraphSm',
                fontWeight: '300',
                letterSpacing: remCalc(0.6),
            },
            expressPaypalBox: {
                w: '100%',
            },
            paypal_container: {
                width: '100%',
            },
        }),
        variants: {
            relativeFooter: {
                wrapperfooter: {
                    p: 'unset',
                    position: 'relative',
                },
            },
        },
    },
}

export default minicartFooter
